"use client";

import * as React from "react";

import { createSVGIcon } from "../../util";

export const Organic = createSVGIcon(
  <>
    <path
      d="M21 18.7715H18.2443V12.3432V11.202H21V18.7715Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2439 12.6474C17.8995 12.6474 17.555 12.6474 17.1723 12.6474C16.5982 12.6474 15.9858 12.6474 15.4117 12.7235C14.3784 12.8756 13.4215 13.218 12.4265 13.4843C12.2351 13.5223 12.0437 13.5984 11.8524 13.5984H9.05844C8.59916 13.5984 8.17816 13.9787 8.17816 14.4732C8.17816 15.0058 8.59916 15.4242 9.13498 15.4242C9.51771 15.4242 9.90044 15.4242 10.2832 15.4242C10.819 15.4242 11.3548 15.4242 11.8906 15.4242C12.3116 15.4242 12.8092 15.5002 13.1154 15.8045"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.13504 15.424C7.98685 15.3099 6.83867 15.0056 5.8053 14.5872C5.30775 14.397 4.8102 14.1688 4.31266 13.9025C4.08302 13.7884 3.85338 13.6743 3.58547 13.7503C3.39411 13.7884 3.20274 13.9025 3.1262 14.0546C2.85829 14.4731 3.04965 14.9675 3.39411 15.2718C3.39411 15.2718 5.61393 17.44 8.98195 18.0106C9.63259 18.1247 10.245 18.2007 10.8956 18.2007C11.7759 18.2007 12.6179 18.0486 13.4982 17.8964C14.034 17.7823 14.5698 17.7063 15.1056 17.5921C15.6032 17.478 16.1007 17.2878 16.6365 17.2878H18.2823"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7282 13.0274C13.7282 13.0274 13.2306 12.3427 12.3503 11.658C10.7811 10.4028 8.48477 10.7451 7.33659 12.3427C6.95386 12.8752 6.6094 13.5219 6.34149 14.3967"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.1687 10.8977C10.1687 10.8977 9.67117 4.8878 14.1108 4.8878C14.1108 4.8878 13.996 8.34923 10.3984 8.38726"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3214 8.31115C10.3214 8.31115 10.7424 4.77365 7.14479 3.1C7.14479 3.1 6.49415 6.90376 10.1683 8.38723"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Organic",
  { viewBox: "0 0 24 24", titleAccess: "Organic", fill: "none" }
);
